<template>
  <div>
    <b-card v-if="$route.params.id">
      <b-row>
        <b-col class="col-md-2">
          <div class="flex_column">
            <b class="mb-25">№</b>
            <b>#{{ GET_APPLICATIONS_MATERIAL_ID.id }}</b>
          </div>
        </b-col>

        <b-col class="col-md-2">
          <div class="flex_column">
            <b class="mb-25">{{$t('date')}}</b>
            <b>{{$dayjs(GET_APPLICATIONS_MATERIAL_ID.created_at).format("DD.MM.YYYY")}}</b>
          </div>
        </b-col>

        <b-col class="col-md-2">
          <div class="flex_column align-items-center">
            <b class="mb-25">{{$t('status')}}</b>
            <b-badge
              v-if="GET_APPLICATIONS_MATERIAL_ID.status"
              :variant="GET_APPLICATIONS_MATERIAL_ID.status.color"
            >
              {{ GET_APPLICATIONS_MATERIAL_ID.status.name }}
            </b-badge>
          </div>
        </b-col>
      </b-row>
    </b-card>

    <validation-observer ref="materialValidate">
      <b-card>
        <div class="material">
          <div class="d-flex align-items-center justify-content-between">
            <h4>{{$t('reference.material')}}</h4>

            <b-button variant="primary" @click="onSubmitMaterial" id="add-material-inside-modal-open">
              <feather-icon icon="PlusIcon" size="16" />
              {{$t('add')}}
            </b-button>
          </div>
          <hr />
        </div>

        <b-table
          :fields="fieldsTable"
          :items="allData.goods"
          responsive
          hover
          :empty-text="$t('empty_text')"
          show-empty
        >
          <template #head()="props">
            <span>{{ $t(props.label) }}</span>
          </template>

          <template #cell(numeration)="props">
            <span>{{ props.index + 1 }}</span>
          </template>

          <template #cell(brigade)="props">
            <span v-if="props && props.item && props.item.brigade && props.item.brigade.title">{{ props.item.brigade.title }}</span>
          </template>

          <template #cell(category)="props">
            <span>{{ $t(props.label) }}</span>
          </template>
        
          <template #cell(unity)="props">
            <span>{{ props && props.item && props.item.good_id && props.item.good_id.unity ? props.item.good_id.unity : '' }}</span>
          </template>

          <template #cell(actions)="props">
            <b-button 
              size="sm" 
              variant="warning"
              @click="materialEdit(props)"
              class="mt-50 mb-50"
            >
              <feather-icon icon="EditIcon" size="15" />
            </b-button>

            <b-button
              size="sm"
              variant="danger"
              class="ml-50 mt-50 mb-50"
              @click="removeItem(props)"
            >
              <feather-icon icon="TrashIcon" size="15" />
            </b-button>
          </template>
        </b-table>

        <div class="warehouse mt-2">
          <h4>{{$t('sidebar.warehouse')}}</h4>
          <hr />

          <b-row>
            <b-col md="3">
              <b-form-group :label="$t('destination_warehouse')">
                <validation-provider
                  #default="{ errors }"
                  :name="$t('destination_warehouse')"
                  rules="required"
                >
                  <v-select
                    v-model="allData.storage"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="title"
                    :options="GET_WAREHOUSE"
                    :reduce="(p) => p.id"
                    :disabled="true"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
        </div>
      </b-card>

      <div class="d-flex align-items-center justify-content-end mt-3">
        <b-button class="mr-1" variant="outline-secondary" @click="cancel">
          {{ $t("cancel") }}
        </b-button>

        <b-button
          :variant="$route.params.id ? 'warning' : 'success'"
          :disabled="buttonPressed"
          @click="saveAllActions"
        >
          {{ $t("save") }}
        </b-button>
      </div>
    </validation-observer>

    <fields :materialss="materialss" @onSave="onSave" />
  </div>
</template>

<script>
import {
  BFormGroup,
  BRow,
  BCol,
  BButton,
  BCard,
  BTable,
  BBadge
} from "bootstrap-vue";
import vSelect from "vue-select";
import Ripple from "vue-ripple-directive";
import { required } from "@core/utils/validations/validations";
import { mapActions, mapGetters } from "vuex";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import areYouSure from "@/mixins/areYouSure";
import objective from "@/mixins/objective";
import fields from "./fields.vue";
import useJwt from "@/auth/jwt/useJwt";
import loader from "@/mixins/loader";

export default {
  name: "AddMaterial",
  components: {
    BRow,
    BCol,
    BButton,
    BFormGroup,
    vSelect,
    BCard,
    BTable,
    fields,
    ValidationObserver,
    ValidationProvider,
    BBadge
  },
  directives: {
    Ripple,
  },
  mixins: [areYouSure, objective, loader],
  data() {
    return {
      required,





      // ===============  PRIMARY_DATA_SECTION START ===============
      fieldsTable: [
        {
          label: "№",
          key: "numeration",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "brigade",
          key: "brigade",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "reference.categoriya",
          key: "category.title",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "table.product_type",
          key: "title.title",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "nomenclature",
          key: "good_id.value",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "unit_of_measurement",
          key: "unity",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "amount",
          key: "count",
          thClass: "text-center",
          tdClass: "text-center",
        },
         {
          label: "contact.comment",
          key: "comment",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "actions",
          key: "actions",
          thClass: "text-center",
          tdClass: "text-center",
        },
      ],

      allData: {
        goods: [],
        storage: null,
        device: {type: "desktop"}
      },

      materialss: {},
      index: null,
      buttonPressed: false,
      // ===============  PRIMARY_DATA_SECTION END ===============





    };
  },
  computed: {
    ...mapGetters("obectsWarehouse", ["GET_WAREHOUSE"]),
    ...mapGetters("application", ["GET_APPLICATIONS_MATERIAL_ID"])
  },
  watch: {
    'allData.goods': {
      deep: true,
      handler(newValue){
        
      }
    }
  },

  async mounted() {



    // await this.$_loaderStart();

    // ===============  PRIMARY_REQUESTS_SECTION START ===============
    const { storage_object } = useJwt.getUserData();

    await this.FETCH_WAREHOUSE({ mini: true, is_object: true });
    this.allData.storage = storage_object ?? null;
    if (this.$route.params.id) {
      await this.FETCH_APPLICATIONS_MATERIAL_ID({id: this.$route.params.id, params: {show_archive: 1}}).then(() => {
          const { objects, storage } = this.GET_APPLICATIONS_MATERIAL_ID;

          this.allData.goods = objects.map(el => ({
            id: el.id,
            category: el.good.product.category,
            count: el.count,
            title: el.good.product,
            good_id: el.good,
            comment: el.responsible,
          }));
          this.allData.storage = storage.id;
        });
    }
    // ===============  PRIMARY_REQUESTS_SECTION START ===============




  },
  // async beforeRouteLeave(to, from, next) {
  //   await this.$_loaderStop();
  //   next();
  // },
  methods: {
    ...mapActions("application", [
      "CREATE_APPLICATIONS_MATERIAL",
      "FETCH_APPLICATIONS_MATERIAL",
      "FETCH_APPLICATIONS_MATERIAL_ID",
      "UPDATE_APPLICATION_MATERIAL",
      "DELETE_MATERIAL_INSIDE"
    ]),
    ...mapActions("obectsWarehouse", ["FETCH_WAREHOUSE"]),









    // ===============  ON_SUBMIT_SECTION START ===============
    onSubmitMaterial() {
      this.materialss = {};
      this.index = null;
      this.$nextTick(() => {
        this.$bvModal.show("modal-field");
      });
    },
    findFirstIndex(){
      let a = ''
      this.allData.goods.forEach((elem2, index2) => {
        a = this.allData.goods.findIndex((elem, index) => {
            if(elem.good_id.id == elem2.good_id.id){
              return elem
            }
        })
      })
      return a
    },
    findSecondIndex(){
      let a = ''
      this.allData.goods.forEach((elem2, index2) => {
        a = this.allData.goods.findLastIndex((elem, index) => {
            if(elem.good_id.id == elem2.good_id.id){
              return elem
            }
        })
      })
      return a
    },
    onSave(el) {
      if (typeof this.index === "number") {
        this.allData.goods.splice(this.index, 1, el);
      } else {
        this.allData.goods.push(el);
      }

      this.allData.goods.forEach((elem, index) => {

        let count = 0;
        let firstIndex = '';
        let secondIndex = '';

        this.allData.goods.forEach((elem2, index2) => {
          if(elem2.good_id.id == elem.good_id.id){
            count++;
          }
        })


        if(count == 2){
          firstIndex = this.findFirstIndex()
          secondIndex = this.findSecondIndex()

          this.allData.goods[firstIndex].count = parseFloat((this.allData.goods[firstIndex].count).toString().replace(/,/g, ''))
           + parseFloat((this.allData.goods[secondIndex].count).toString().replace(/,/g, ''))


          this.allData.goods[firstIndex].count = parseFloat(this.allData.goods[firstIndex].count);
          this.allData.goods[firstIndex].count = new Intl.NumberFormat('en-US', {minimumFractionDigits: 0, maximumFractionDigits: 2}).format(this.allData.goods[firstIndex].count);
          this.allData.goods.splice(secondIndex, 1)
        }
      })

    },
    async saveAllActions() {
      this.$refs.materialValidate.validate().then(async success => {
        this.buttonPressed = true
        setTimeout(() => {
          this.buttonPressed = false
        }, 2000)
        if (!success) return;

        // eslint-disable-next-line prefer-const
        let { goods, ...rest } = this.allData;

        goods = goods.map(e => {

          let a = {
            id: e.id ? e.id : null,
            good_id: e.good_id.id ? e.good_id.id : e.good_id,
            count: parseFloat(e.count.toString().replace(/,/g, '')),
            comment: e.comment,
          }

          if(e.brigade && e.brigade.id){
            a.brigade = e.brigade.id
          }

          return a
        })
        
        

        const data = {goods, ...rest};
        if (this.$route.params.id) {
          await this.UPDATE_APPLICATION_MATERIAL({
            id: this.$route.params.id,
            goods,
            ...rest
          }).then(async () => {
            await this.FETCH_APPLICATIONS_MATERIAL();
            this.$router.push({ name: "applications-material" });
          });
        } else {
          await this.CREATE_APPLICATIONS_MATERIAL(data).then(async () => {
            await this.FETCH_APPLICATIONS_MATERIAL();
            this.$router.push({ name: "applications-material" });
          });
        }
      });
    },
    // ===============  ON_SUBMIT_SECTION END ===============









    // ===============  EDIT_SECTION START ===============
    materialEdit(props) {
      this.materialss = props.item;
      this.index = props.index;
      this.$route.params.editMode = true
      this.$nextTick(() => {
        this.$bvModal.show("modal-field");
      });
    },
    // ===============  EDIT_SECTION START ===============








    // ===============  CANCEL_SECTION START ===============
    cancel() {
      this.allData.goods = [
        {
          category: "",
          good_id: "",
          count: null,
          status: false
        }
      ];
      this.$router.back();
    },
    // ===============  CANCEL_SECTION END ===============









    // ===============  REMOVE_SECTION START ===============
    async removeItem(props) {
      if (props.item.id) {
        this.$_showAreYouSureModal().then(async (val) => {
          if (val) {
            await this.DELETE_MATERIAL_INSIDE(props.item.id)
              .then(() => {
                this.allData.goods.splice(props.index, 1);
                this.$_okToast();
              })
              .catch(err => {
                this.$_errToast(err);
              });
          }
        });
      } else {
        this.allData.goods.splice(props.index, 1);
      }
    }
    // ===============  REMOVE_SECTION END ===============








  }
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";

.flex_column {
  display: flex;
  flex-direction: column;
}
</style>
